<template>
  <div id="stud_main">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>


<div class="columns is-gapless is-mobile has-text-grey-dark" style="margin-bottom:0em;">

<div class="column is-2 colBorder has-text-centered has-background-grey-lighter">Session</div>
<div class="column is-6 colBorder has-text-centered has-background-grey-lighter">Cours</div>
<div class="column is-2 colBorder has-text-centered has-background-grey-lighter">Note</div>
<div class="column is-2 colBorder has-text-centered has-background-grey-lighter">Moyenne</div>
</div>

 

    <CompCourseList v-for ="(data, index) in data_student" :key="index"
      :student_id="student_id"
      :data="data">
    </CompCourseList>


  </div>
</template>


<script>
import axios from 'axios';
import  CompCourseList  from '@/views/Student/Course_List'

export default {
    props: [ 'student_id' ],
    components: { CompCourseList },

  data: function() {
    return {
        isLoading : false,

        data_student:[],
    }
  },


created() {
  this.get_courses()

},

  methods: {

get_courses() {



  this.isLoading=true;
        var query=`SELECT MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_GROUP.group_CODE,CAST(IIF ( group_PUBLIC = 1, 1, 0 ) AS BIT) as goodToGo ,group_PUBLIC,
        MyMEQ_GROUP.group_SESS + MyMEQ_GROUP.group_ANN as grpSessAnn, MyMEQ_GROUP.group_AVG, group_datEND,MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, MyMEQ_GROUP.group_ID 
        ,PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2
        FROM MyMEQ_COURSESTUDENT INNER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN  MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID 
        LEFT OUTER JOIN  MyMEQ_STAFF AS PROF2 ON MyMEQ_GROUP.staff_ID_2 = PROF2.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON MyMEQ_GROUP.staff_ID_1 = PROF1.staff_ID  
        WHERE (MyMEQ_COURSESTUDENT.student_ID = ` + this.student_id + `) 
        ORDER BY MyMEQ_GROUP.group_SESS, MyMEQ_GROUP.group_ANN DESC`
console.log(query)
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { 
            this.data_student = res.data
            this.isLoading=false;
        });

},



  }, // END METHODS 

} // END SCRIPT
</script>




<style scoped>



</style>
